import axios from "axios";
import * as turf from "@turf/turf";

export default {
    data() {
        return {
            locationResource: [],
            locationResourceIsLoaded: false
        }
    },
    methods: {
        getLocations() {
            let locationUrl = `/api/maps/${this.mapData.id}/locations/${this.mapData.current_locale}`;
            axios
                .get(!this.categoryId ? locationUrl : locationUrl + `?c=${this.categoryId}`)
                .catch(function (error) {
                    console.log(error.toJSON());
                })
                .then((response) => {
                    var data = response.data;
                    data.forEach(el => {
                        let { lng, lat, ...properties } = el

                        properties.category = this.categoryData.find((cat) => cat.id == el.category_id);
                        properties.banners = this.bannerResource.filter(item => item.location_ids.includes(el.id));
                        properties.items = this.itemResource.filter(item => item.location_ids.includes(el.id));
                        properties.facilities
                            = this.facilityResource.filter(item => item.location_ids.includes(el.id));
                        properties.upper_areas = el.area_id ? this.getUpperAreas(el.area_id) : [];
                        properties.audio_guide = this.audioGuides.find(item => item.id == el.audio_guide_id);
                        properties.current_congestion = this.congestionResource.find(cog => cog.location_id == el.id);
                        properties.tags = properties.tags ? properties.tags.split(",") : [];
                        properties.individual_link = properties.individual_link ? JSON.parse(properties.individual_link) : [];
                        properties.sns_link = properties.sns_link ? JSON.parse(properties.sns_link) : [];
                        properties.custom_fields = JSON.parse(properties.custom_fields)
                        properties.images = properties.images ? this.generateURLOfImages(JSON.parse(properties.images)) : [];
                        properties.videos = properties.videos ? JSON.parse(properties.videos) : []
                        properties.marker_image_url = this.getMarkerImageURL(el.marker_image);
                        properties.illustration_image = this.illustrationImageResource.find((item) => item.id == el.illustration_image_id);

                        let temp = turf.point([Number(lng), Number(lat)], properties);
                        this.locationResource.push(temp);
                    });
                    this.locationResourceIsLoaded = true;
                });
        },
        getMarkerImageURL(markerImage) {
            const imgPath = '/storage/image/';
            const iconPath = '/storage/icon/';
            const defaultMarkerImage = this.mapData.default_marker_image ? imgPath + this.mapData.default_marker_image : '/img/no-image_star.png';
            if (!markerImage) {
                return defaultMarkerImage;
            }

            const pattern = new RegExp(/^[A-Za-z0-9]+.(?:jpe?g|svg|png)$/, 'i');
            return pattern.test(markerImage) ? iconPath + markerImage : markerImage;
        },
        generateURLOfImages(images) {
            var result = [];
            var domainOrigin = window.location.origin;
            const imgPath = '/storage/image/';

            images.forEach((img) => {
                const pattern = new RegExp(/^[A-Za-z0-9]+.(?:jpe?g|svg|png)$/, 'i');
                const imgURL = pattern.test(img) ? domainOrigin + imgPath + img : img;
                result.push(imgURL);
            });

            return result;
        },
        getUpperAreas(areaId) {
            var result = [];
            const level1 = this.areaResource.find(el => el.id == areaId);
            if (!level1) {
                return result;
            }

            result.unshift(level1)
            const level2 = this.areaResource.find(el => el.id == level1.upper_area_id)
            if (!level2) {
                return result;
            }

            result.unshift(level2);
            const level3 = this.areaResource.find(el => el.id == level2.upper_area_id)
            if (!level3) {
                return result;
            }
            result.unshift(level3)

            return result;
        },
        getIllustrationImageURL(illustrationImage) {
            const iconPath = '/storage/icon/';
            const pattern = new RegExp(/^[A-Za-z0-9]+.(?:jpe?g|svg|png)$/, 'i');
            return pattern.test(illustrationImage) ? iconPath + illustrationImage : illustrationImage;
        },
    }
};